import React from "react";
// --- Import Components
import ErrorBoundary from "../../components/ErrorBoundary/ErrorBoundary";
import TransactionTable from "./TransactionTable/TransactionTable";

import classes from "./Transaction.module.sass";

function Transaction() {
  return (
    <article className={classes.transaction}>
      <section className={classes.transaction_title}>
        <h3>Transaction History</h3>
      </section>
      <ErrorBoundary
        classWrapper="payment-section__error"
        classText="payment-section__error-text"
      >
        <TransactionTable />
      </ErrorBoundary>
    </article>
  );
}

export default Transaction;
